import Rails from 'rails-ujs';

// site-wide
import activateChosen from './sitewide/activateChosen';
import activateFroala from './sitewide/activateFroala';
import activatePopper from './sitewide/activatePopper';
import activateQuizSessionTimer from "./sitewide/activateQuizSessionTimer";
import activateSelectBoxIt from './sitewide/activateSelectBoxIt';
import activateSortable from './sitewide/activateSortable';
import activateTippable from './sitewide/activateTippable';

// page-specific
import initDashboard from './pageSpecific/initDashboard';
import initHomepage from "./pageSpecific/initHomepage";
import initQuizSession from "./pageSpecific/initQuizSession";
import initSchoolSelection from "./pageSpecific/initSchoolSelection";

Rails.start();

$(document).ready(function () {
  activateFroala('.froala-editor');
  activateChosen('.chosen-select');
  activatePopper('.has-tippy');
  activateQuizSessionTimer();
  activateSelectBoxIt('.selectboxit');
  activateSortable('.is-sortable');
  activateTippable('.tippable');

  initDashboard();
  initHomepage();
  initQuizSession();
  initSchoolSelection();
});
